import { SET_MENU_DATA, SET_BECOME_CLIENT_POPUP_VARIANT } from '../actionTypes/menu';
import { getMenu } from '~/src/api/content/menu';
import { BECOME_CLIENT, LABEL_BECOME_CLIENT, SHOWING_MENU_ITEMS } from '~/src/helpers/city';
import { getABNVariant } from '~/src/helpers/abn-tests';
import { selectDomain } from '~/src/store/selectors/domain';

export const setMenuData = (newMenuItems) => ({
    type: SET_MENU_DATA,
    payload: newMenuItems,
});

export const setBecomeClientPopupVariant = (data) => ({
    type: SET_BECOME_CLIENT_POPUP_VARIANT,
    payload: data
});

export function getMenuData(req, res) {
    return async(dispatch, getState) => {
        const state = getState();
        const domainCity = selectDomain(state);

        const abnTests = state?.city?.currentCity?.abnTests;
        const abnVariantMenuItems = getABNVariant({ abnTests, testName: SHOWING_MENU_ITEMS, req, res });

        const resp = await getMenu(domainCity, abnVariantMenuItems?.id);

        if (resp.isSuccess) {
            dispatch({
                type: SET_MENU_DATA,
                payload: {
                    newMenuItems: resp.payload,
                },
            });
        }
    };
}

export const getBecomeClientVariant = (req, res) => {
    return async(dispatch, getState) => {
        const state = getState();
        const prevEnableBecomeClientPopup = state?.menu?.enableBecomeClientPopup;
        const abnTests = state?.city?.currentCity?.abnTests;
        const abnVariant = req ? getABNVariant({ abnTests, testName: BECOME_CLIENT, req, res }) : null;
        const enableBecomeClientPopup = prevEnableBecomeClientPopup || abnVariant?.label === LABEL_BECOME_CLIENT;

        dispatch(setBecomeClientPopupVariant(enableBecomeClientPopup));
    };
};
